import React, {useRef} from 'react';
import {useParams} from 'react-router-dom';
import {VerdocsEndpoint} from '@verdocs/js-sdk';
import {VerdocsSign} from '@verdocs/web-sdk-react';
import {track, trackFieldNotVisible} from '../../Managers/Analytics';
import {FlexFill} from '../../Components';
import {CONFIG} from '../../config';

export const SignAnonymously: React.FC = () => {
  const {id = '', role = '', code = ''} = useParams();
  const endpoint = useRef(new VerdocsEndpoint({sessionType: 'signing', baseURL: CONFIG.API_URL}));

  // Signers are never identified. The invite code is a bearer credential and never leaves the app.
  const signingProps = (e: any) => ({envelope_id: id, org_id: e?.detail?.envelope?.organization_id || '', role_name: role});

  return (
    <div className="flex flex-col inset-0 z-50 h-full absolute overscroll-y-auto bg-[#f6f8fa]">
      <VerdocsSign
        endpoint={endpoint.current}
        envelopeId={id}
        roleId={role}
        inviteCode={code}
        onEnvelopeLoaded={(e: any) => track('signing_started', signingProps(e))}
        onEnvelopeUpdated={(e: any) => e.detail?.event === 'submitted' && track('signing_submitted', signingProps(e))}
        onFieldNotVisible={(e: any) => trackFieldNotVisible(e.detail)}
      />

      <FlexFill />
    </div>
  );
};
